import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const categoryLinks = [
  { key: "shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { key: "hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { key: "tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { key: "jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { key: "pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { key: "headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { key: "sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { key: "underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { key: "jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { key: "accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { key: "bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { key: "belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { key: "perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { key: "other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

export default function Home() {
  const { t, i18n } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleCategoryChange = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
    setDropdownOpen(false);
  };

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-lg font-semibold text-gray-900 tracking-tight">
              CSSBuy Spreadsheet
            </Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                {t("nav.home")}
              </Link>
              <Link to="/article" className="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                {t("nav.article")}
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
              >
                {t("nav.ctaMain")}
              </a>
            </nav>
            <div className="flex items-center gap-2">
              <span className="text-xs text-gray-400 hidden sm:inline">{t("language")}</span>
              <div className="flex gap-1">
                {["en", "pt", "de"].map((lang) => (
                  <button
                    key={lang}
                    onClick={() => changeLanguage(lang)}
                    className={`px-2 py-1 text-xs rounded-md transition-colors ${
                      i18n.language === lang
                        ? "bg-gray-900 text-white"
                        : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                  >
                    {lang.toUpperCase()}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative pt-16 min-h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Premium%20fashion%20products%20flat%20lay%20photography%20on%20white%20marble%20background%2C%20sneakers%20hoodies%20accessories%20arranged%20aesthetically%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20clean%20minimal%20composition%2C%20high%20end%20product%20photography&width=1600&height=900&seq=hero-2026-x1&orientation=landscape"
            alt="CSSBuy Spreadsheet Products"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center text-white">
          <p className="text-sm font-medium tracking-widest uppercase mb-4 opacity-90">
            {t("hero.eyebrow")}
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
            {t("hero.title")}
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t("hero.description")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-8 py-3 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              {t("hero.ctaPrimary")}
            </a>
            <Link
              to="/article"
              className="inline-flex items-center justify-center px-8 py-3 bg-white/10 text-white border border-white/30 rounded-lg font-medium hover:bg-white/20 transition-colors"
            >
              {t("hero.ctaSecondary")}
            </Link>
          </div>
          <p className="text-sm text-white/70">{t("hero.trust")}</p>
        </div>
      </section>

      {/* Categories Dropdown Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8">
            {t("categories.title")}
          </h2>

          {/* Custom Dropdown */}
          <div className="relative max-w-md mx-auto mb-12">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-700 hover:border-gray-300 transition-colors"
            >
              <span>{selectedCategory ? t(`categories.${selectedCategory}`) : t("categories.dropdownLabel")}</span>
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {dropdownOpen && (
              <div className="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                {categoryLinks.map((cat) => (
                  <button
                    key={cat.key}
                    onClick={() => {
                      setSelectedCategory(cat.key);
                      handleCategoryChange(cat.url);
                    }}
                    className="w-full text-left px-4 py-3 hover:bg-gray-50 text-gray-700 transition-colors"
                  >
                    {t(`categories.${cat.key}`)}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Category Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {categoryLinks.map((cat) => (
              <a
                key={cat.key}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center px-3 py-2 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 hover:border-gray-400 hover:shadow-sm transition-all text-center"
              >
                {t(`categories.${cat.key}`)}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Article Preview Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="w-full md:w-1/2">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20showing%20spreadsheet%20data%2C%20minimal%20white%20desk%2C%20coffee%20cup%2C%20clean%20aesthetic%2C%20soft%20natural%20lighting%20from%20window%2C%20editorial%20photography%20style%2C%20warm%20neutral%20tones&width=800&height=600&seq=article-preview-01&orientation=landscape"
                alt="CSSBuy Spreadsheet Guide"
                className="w-full rounded-xl object-cover"
              />
            </div>
            <div className="w-full md:w-1/2">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Guide</span>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-2 mb-4">
                {t("article.title")}
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {t("article.description")}
              </p>
              <Link
                to="/article"
                className="inline-flex items-center text-gray-900 font-medium hover:underline"
              >
                {t("article.readMore")}
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">{t("cta.title")}</h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-10 leading-relaxed">
            {t("cta.description")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-8 py-3 bg-white text-gray-900 rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              {t("cta.button1")}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-8 py-3 bg-gray-800 text-white border border-gray-700 rounded-lg font-medium hover:bg-gray-700 transition-colors"
            >
              {t("cta.button2")}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-8 py-3 bg-gray-800 text-white border border-gray-700 rounded-lg font-medium hover:bg-gray-700 transition-colors"
            >
              {t("cta.buttonBuy")}
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 bg-gray-50 border-t border-gray-200">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-gray-500 mb-2">{t("footer.disclaimer")}</p>
          <p className="text-xs text-gray-400">{t("footer.copyright")}</p>
          <div className="mt-4 flex justify-center gap-4">
            <Link to="/" className="text-xs text-gray-500 hover:text-gray-700">{t("nav.home")}</Link>
            <Link to="/article" className="text-xs text-gray-500 hover:text-gray-700">{t("nav.article")}</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-gray-500 hover:text-gray-700">
              {t("nav.ctaMain")}
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}